import styledComp from 'styled-components';

export const WatermarkThumbnail = styledComp.img`
  width: 56px;
  height: 56px;
  object-fit: contain;
  margin: 0;
  padding: 0;
  margin-right: 10px;
`;

export const WatermarkOption = styledComp.div`
  display: flex;
  align-items: center;
`;

export const ExchangeClipsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: 5px;
  }
`;
